import bulkRoutes from '@/modules/uploadCSV/routes/index'

export default [
  ...bulkRoutes
]